import React from 'react';
import type { SuffixIconName } from '@/types/chatbot.types';
import NewInsightLabel from './NewInsightLabel';
import PackageCareIcon from './PackageCareIcon';

export const widgetIcons: Record<SuffixIconName, React.ComponentType> = {
  newLabel: NewInsightLabel,
  packageCare: PackageCareIcon,
};

export const getWidgetIcon = (iconName?: SuffixIconName | string): React.ComponentType | null => {
  if (!iconName) return null;

  const widgetIcon = widgetIcons[iconName as SuffixIconName];
  return widgetIcon || null;
};
